/* esm.sh - rxjs@7.8.1/dist/esm/internal/config */
var e={onUnhandledError:null,onStoppedNotification:null,Promise:void 0,useDeprecatedSynchronousErrorHandling:!1,useDeprecatedNextContext:!1};export{e as config};
//# sourceMappingURL=config.mjs.map